import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {TicketsService,TestequipService,UserService,FavoriteService,MessageService} from 'src/app/services/'
import {CreateTicketFormFields} from 'src/app/models/tickets/createTicketFormFields'
import {EquipmentUsedDuringRepair} from 'src/app/models/tickets/equipmentUsedDuringRepair'
import { SelectItem } from 'primeng/api/selectitem';
import { AccessUserInfo, UserDetail } from 'src/app/models';
@Component({
  selector: 'bart-test-equipment-used',
  templateUrl: './test-equipment-used.component.html',
  styleUrls: ['./test-equipment-used.component.scss']
})
export class TestEquipmentUsedComponent implements OnInit {
  userId:number=0;
  favoriteListTypeId=2
  public formFields:CreateTicketFormFields;
  public testEquipmentColumnList:any;
  public testEquipmentData:any[]

  public favoritesEquipmentId:number=null;
  public favoritesEquipmentSerial:string=null;
  public selectedFavListValue:SelectItem;
  public displayFavModal:boolean=false;

  public favListTestEquipmentData:any[]=[];  //for grid
  public favListTestEquipment:SelectItem[]=[];// for dropdown
  public ddlPopupFavList:SelectItem[]=[];// add to favorite list popup dropdown
  public allFavListTestEquipment:any[]=[];//for filter
  public selectedtestEquipmentData:any;
  public selectedfavListTestEquipmentData:any;
  public searchTerm:string="";
  public showLoader:boolean=false;
  public showFavTestEquipment:boolean=false;
  public favtestEquipmentColumnList:any;
  public isAddNewList:boolean=false;
  public favListName:string="";
  public getTestEquipParam = {
    "GETTESTEQUIP": {
      str: null,
    },
  }
  constructor
  (
    private _ticketService:TicketsService,
    private _testequipService:TestequipService,
    private _userService:UserService,
    private _favoriteService:FavoriteService,
    private _messageService:MessageService,
    private changeDetectorRef: ChangeDetectorRef
  ) 
  {
    this.formFields=new CreateTicketFormFields()
  }
  ngOnInit() {
    let userInfo:UserDetail = AccessUserInfo.getUserInfo();
      this.userId=userInfo.userId;
      this._ticketService.getTicketGlobalData().subscribe((Result: any) => {   
        this.formFields=Result;
      }, 
      (error) => {
        console.log(error);
      }
    );
    this.testEquipmentColumnList = [
      { field: 'EquipmentID', header: 'Equipment Id' },
      { field: 'EquipmentSubTypeCode', header: 'Sub Type' },
      { field: 'manufacturerName', header: 'Manufacturer' },
      { field: 'ModelNumber', header: 'Model' },
      { field: 'equipmentserialnumber', header: 'Serial Number' },
      { field: 'equipmentdescription', header: ' Equipment Description' },
      { field: 'DivisionName', header: 'Division'},              
    ];
    this.favtestEquipmentColumnList = [
      { field: 'EquipmentID', header: 'Equipment Id' },
      { field: 'EquipmentSubTypeCode', header: 'Sub Type' },
      { field: 'ManufacturerName', header: 'Manufacturer' },
      { field: 'ModelNumber', header: 'Model' },
      { field: 'EquipmentSerialNumber', header: 'Serial#' },
      { field: 'EquipmentDescription', header: 'Equipment Description' },
                
    ];
    this.bindFavList();
    this.getFavoriteList();
  }
  public bindFavList()
  {
    let GETFAVORITELISTTESTEQUIP = {
        favoriteListId: 0,
        favoriteListTypeId:this.favoriteListTypeId,
        favoriteListTestEquipId:0,
        sortColumn:"favoriteListName ASC, equipmentID ASC",
        activeTestEquip:1,
        userId:this.userId
    }

    if (GETFAVORITELISTTESTEQUIP != null) {

      this._favoriteService.getFavoriteListTestEquip(JSON.stringify({GETFAVORITELISTTESTEQUIP}) )
        .subscribe((response: any) => {
         if (response.records.length > 0)
          {
            this.allFavListTestEquipment=response.records
          // //Start:Filter Disticnt Record & Sort
          //   this.allFavListTestEquipment= this.allFavListTestEquipment.filter(
          //     (thing, i, arr) => arr.findIndex(t => t.favoritelistid=== thing.favoritelistid) === i
          //   );
          //   this.allFavListTestEquipment.sort((a,b) => a.favoritelistname.localeCompare(b.favoritelistname));
          // //End:Filter Disticnt Record & Sort
            this.favListTestEquipmentData=this.allFavListTestEquipment;
            this.favListTestEquipment=this.allFavListTestEquipment.map(data => ({ 
              label: data.favoritelistname , 
              value: data.favoritelistid,
              }));
              //Start:Added By Harikesh on 17-Oct-2020 for Defect#12312
              this.favListTestEquipment= this.favListTestEquipment.filter
              (
                    (thing, i, arr) => arr.findIndex(t => t.value=== thing.value) === i
              );
               //End:Added By Harikesh on 17-Oct-2020 for Defect#12312
        }
        }, (error) => {
          this.allFavListTestEquipment=[];
          console.log(error);
        }
        );
    }
  }
  public bindTestEquipmentGrid()
  {
    this.showLoader=true
    this.getTestEquipParam.GETTESTEQUIP.str=this.searchTerm;
    this.testEquipmentData=[];
    if (this.getTestEquipParam != null) {
      this._testequipService.getTestEquip(JSON.stringify( this.getTestEquipParam))
        .subscribe((response: any) => {
         this.testEquipmentData=response;
         //Bart enhancement 2020 - Remove qouates from start ane end EquipmentSerialNumber(SPR-1402) -- starts here
         this.testEquipmentData.forEach(item => item.equipmentserialnumber = item.equipmentserialnumber.replace(/"/g, ''));
         //Bart enhancement 2020 - Remove qouates from start ane end EquipmentSerialNumber (SPR-1402)-- ends here
         this.showLoader=false
        }, (error) => {
          this.testEquipmentData=null;
          this.showLoader=false
          console.log(error);
        }
        );
    }
  }
  public async SaveFavorites()
  {
   
    let addFavoriteListTestEquipParam = {
        "ADDFAVORITELISTTESTEQUIP": {
          equipmentId: this.favoritesEquipmentId,
          favoriteListId:this.selectedFavListValue!=null?this.selectedFavListValue.value:null
        }
    }
    if (!this.selectedFavListValue) {
      this._messageService.showAlertMessage("Please choose a list");
      return false;
    }
    if(this.selectedFavListValue.value==0)
    {
      if (this.favListName == "") {
        this._messageService.showAlertMessage("Please enter a name for the list");
				return false;
      }
      let nameExists = await this.checkFavoriteListName(this.favListName,this.favoriteListTypeId,null);
      if (nameExists) {
        this._messageService.showAlertMessage("A list with that name already exists");
				return false;	
      }
      let ADDFAVORITELIST = {
        favoriteListTypeId : this.favoriteListTypeId,
        userId :   this.userId,
        favoriteListName: this.favListName     
      };
      let GETFAVORITELIST = {
        favoriteListTypeId : this.favoriteListTypeId,
        userId :   this.userId,
        favoriteListName: this.favListName 
      }; 
      this._favoriteService.addFavoriteList(JSON.stringify({GETFAVORITELIST, ADDFAVORITELIST}))
      .subscribe((result: any) => {
             this.favListName="";
             if(result!=null && result.records!=null)
             {
               addFavoriteListTestEquipParam.ADDFAVORITELISTTESTEQUIP.favoriteListId=result.records[0].favoriteListId
               this.addToFavoriteListTestEquipment(addFavoriteListTestEquipParam,ADDFAVORITELIST.favoriteListName);
             }
          }, (error) => {
               console.log(error);
        }
      );
    }
    else{
       this.addToFavoriteListTestEquipment(addFavoriteListTestEquipParam,this.selectedFavListValue.label);
    }
 }
public addToFavoriteListTestEquipment(addFavoriteListTestEquipParam:any,FavListName:string)
{
  if (addFavoriteListTestEquipParam != null) {
    this._favoriteService.addFavoriteListTestEquip(JSON.stringify(addFavoriteListTestEquipParam))
      .subscribe((response: any) => {
       if(response.addRecord!=null)
       {
         //alert("Test Equipment Saved.")
         this._messageService.showAlertMessage("Test Equipment Saved to '"+FavListName+"' List")
         this.displayFavModal=false;
         this.selectedFavListValue=null
         this.reFreshGrid()
       }
      }, (error) => {
        this.testEquipmentData=null;
        console.log(error);
      }
      );
  }
}
 public async checkFavoriteListName (favoriteListName: string,favoriteListTypeId: number,favoriteListId:string)
 {
  
   let nameExists:boolean= false;

   var GETFAVORITELIST:any = { favoriteListName:favoriteListName, favoriteListTypeId:favoriteListTypeId,
     favoriteListId:favoriteListId,check:1
   ,userId:this.userId };
     
   await this._favoriteService.getFavoriteListSync(JSON.stringify({GETFAVORITELIST}) )
   .then((listsResponse: any) => {
   
    let favoriteData = listsResponse;
     
    if(favoriteData.records.length > 0)
    {
     nameExists = true;

    }
   }
   );
   
   return nameExists;
 }

 public reFreshGrid()
  {
    this.bindFavList()
    this.getFavoriteList()
  } 
 public checkFavoriteTestEquip(equipmentId)
 {
   let isExist=false;
   if(this.allFavListTestEquipment!=null)
   {
    if(this.allFavListTestEquipment.filter(x=>x.EquipmentID==equipmentId).length>0)
    {
     isExist=true;
    }
   }
   return isExist;
 }
  public OnRowFEClick()
  {
    
    let rowDetails=this.selectedtestEquipmentData;
    let temEquipmentId=rowDetails["EquipmentID"];
    let eCount=0;
    if(this.formFields.testEquipmentUsedDuringRepair==null)
    {
     this.formFields.testEquipmentUsedDuringRepair=[];
    }
    if(this.formFields.testEquipmentUsedDuringRepair)
     eCount=this.formFields.testEquipmentUsedDuringRepair.filter(x=>x.equipmentId==temEquipmentId).length; 
    if(eCount==0)
    {
      let obj=this.BuildEquipmentUsedObject(rowDetails,"testEquipment")
      this.formFields.testEquipmentUsedDuringRepair.push(obj);

    }
  }
  public OnRowFavEquipmentClick(Rowid:number)
  {
    let rowDetails=this.selectedfavListTestEquipmentData;
    let temEquipmentId=rowDetails["EquipmentID"];
    let eCount=0;
    if(this.formFields.testEquipmentUsedDuringRepair==null)
    {
     this.formFields.testEquipmentUsedDuringRepair=[];
    }
    if(this.formFields.testEquipmentUsedDuringRepair)
     eCount=this.formFields.testEquipmentUsedDuringRepair.filter(x=>x.equipmentId==temEquipmentId).length; 

    if(eCount==0)
    {
      let obj=this.BuildEquipmentUsedObject(rowDetails,"favTestEquipment")
      this.formFields.testEquipmentUsedDuringRepair.push(obj);
    }
  }
  public OpenFavoritesPopup(Rowid:number)
  {
    let rowDetails=this.formFields.testEquipmentUsedDuringRepair[Rowid]
    if(rowDetails!=null)
    {
      this.displayFavModal=true;
      this.favoritesEquipmentId=rowDetails["equipmentId"];
      this.favoritesEquipmentSerial=rowDetails["serialNumber"];
      this.selectedFavListValue=null;
    }
  }
  public RemoveRow(Rowid:number)
  {
    let rowDetails=this.formFields.testEquipmentUsedDuringRepair[Rowid]
    if(rowDetails!=null)
    {
     
      let temequipmentId=rowDetails["equipmentId"];
      
      this.formFields.testEquipmentUsedDuringRepair=this.formFields.testEquipmentUsedDuringRepair.filter(x=>x.equipmentId!=temequipmentId);
      if(this.formFields.testEquipmentUsedDuringRepair.length<=0)
      {
        this.formFields.testEquipmentUsedDuringRepair=null
      }

      if(this.selectedtestEquipmentData !=undefined && this.selectedtestEquipmentData!=null)
    {
      if(this.selectedtestEquipmentData.EquipmentID==temequipmentId)
      {
        this.selectedtestEquipmentData=[];
      }
    }
    if(this.selectedfavListTestEquipmentData !=undefined && this.selectedfavListTestEquipmentData!=null)
    {
    if(this.selectedfavListTestEquipmentData.EquipmentID==temequipmentId)
    {
      this.selectedfavListTestEquipmentData=[];
    }
  }
    }
  }
  public showFavTestEquipmentGrid()
  {
    this.showFavTestEquipment=true;
  }
  public closeFavTestEquipmentGrid()
  {
    this.showFavTestEquipment=false;
  }
  public BuildEquipmentUsedObject(obj:any,souceName:string)
  {
    let  equipmentUsed:EquipmentUsedDuringRepair=null;
    if(souceName=="testEquipment")
    {
        equipmentUsed={ 
        equipmentId:obj.EquipmentID,
        subType:obj.EquipmentSubTypeCode,
        manufacturer:obj.manufacturerName,	
        modelNumber:obj.ModelNumber,	
        serialNumber:obj.equipmentserialnumber,
        equipmentDescription:obj.equipmentdescription,
        dateCalibrated:obj.DateCalibrated
      }
    }
    else if(souceName=="favTestEquipment")
    {
      equipmentUsed={ 
        equipmentId:obj.EquipmentID,
        subType:obj.EquipmentSubTypeCode,
        manufacturer:obj.ManufacturerName,	
        modelNumber:obj.ModelNumber,	
        serialNumber:obj.EquipmentSerialNumber,
        equipmentDescription:obj.EquipmentDescription,
        dateCalibrated:obj.DateCalibrated
      }
    }
    return equipmentUsed;
  }
  
  public filterFavTestEquipment(event)
  {
    this.favListTestEquipmentData=this.allFavListTestEquipment
    if(event.value!=null)
    {
      let favId=event.value.value;
      if(this.allFavListTestEquipment!=null)
      {
        this.favListTestEquipmentData=this.allFavListTestEquipment.filter(x=>x.favoritelistid==favId);
      }
   }
  }

  public getFavoriteList()
  {
    let getFavListParam=
    {
      "GETFAVORITELIST": {
          favoriteListTypeId: this.favoriteListTypeId,
          userId: this.userId,
          favoriteListName: null,
          maxCount: 10,
          check: null,
          favoriteListId: null
      }
    }
    this._favoriteService.getFavoriteList(JSON.stringify(getFavListParam)).subscribe(data=>
      {
        this.ddlPopupFavList=[];
        if (data!=null && data.records.length > 0)
        {
          this.ddlPopupFavList=data.records.map(data => ({ 
            label: data.favoriteListName , 
            value: data.favoriteListId,
          }));
          //this.ddlPopupFavList.push({ label: "New..", value: 0 });
          this.ddlPopupFavList.splice(0, 0, { label: "New..", value: 0 })
        }
        else
        {
          this.ddlPopupFavList=[{label:'New...',value:0}]
        }
      })
  }
}
